import { render, staticRenderFns } from "./ManagementContentPanel.vue?vue&type=template&id=359b2a8f&scoped=true"
import script from "./ManagementContentPanel.vue?vue&type=script&lang=js"
export * from "./ManagementContentPanel.vue?vue&type=script&lang=js"
import style0 from "./ManagementContentPanel.vue?vue&type=style&index=0&id=359b2a8f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b2a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359b2a8f')) {
      api.createRecord('359b2a8f', component.options)
    } else {
      api.reload('359b2a8f', component.options)
    }
    module.hot.accept("./ManagementContentPanel.vue?vue&type=template&id=359b2a8f&scoped=true", function () {
      api.rerender('359b2a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/controlPanel/manageLabels/ManagementContentPanel.vue"
export default component.exports